import type { JSX } from 'react'

import {
  CalendarIcon,
  ChartColumnIcon,
  LightbulbIcon,
  MessagesSquareIcon,
} from '@buffer-mono/popcorn'

type MainNavigationItemKey = 'create' | 'publish' | 'community' | 'insights'

export const MAIN_NAVIGATION_ITEMS: Record<
  MainNavigationItemKey,
  { label: string; icon: JSX.Element }
> = {
  create: { label: 'Create', icon: <LightbulbIcon color="subtle" /> },
  publish: { label: 'Publish', icon: <CalendarIcon color="subtle" /> },
  community: {
    label: 'Community',
    icon: <MessagesSquareIcon color="subtle" />,
  },
  insights: { label: 'Insights', icon: <ChartColumnIcon color="subtle" /> },
}

export function isCreatePath(pathname: string): boolean {
  return pathname.startsWith('/create')
}

export function isCommunityPath(pathname: string): boolean {
  return pathname.startsWith('/community')
}

export function isInsightsPath(pathname: string): boolean {
  return pathname === '/insights' || pathname.startsWith('/insights/habits')
}
